module.exports = __webpack_public_path__ + "media/images/logo-reforestaction-458a892a.png";